import React from "react";
import Loader from "../../../components/Loader";

const FILTER_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Properties", value: "property" },
  { label: "Contacts", value: "contact" },
  { label: "Companies", value: "company" },
];

const cleanInfoString = (str) => {
  if (typeof str === "string") {
    // Removes anything looking like a JSON array at the start of the string, plus trailing commas
    return str.replace(/^\[.*?\]\s*,?\s*/, '');
  }
  return str;
};

const SearchResults = ({ 
  results, 
  query, 
  loading, 
  handleNavigate, 
  selectedFilter, 
  setSelectedFilter,
  containerHeight = "max-h-[500px]"
}) => {
  return (
    <div className="flex flex-col h-full w-full">
      {/* Filters */}
      <div className="flex gap-2 p-3 border-b border-gray-200">
        {FILTER_OPTIONS.map((filter) => (
          <button
            key={filter.value}
            className={`px-3 py-1 rounded-full text-sm font-medium transition ${
              selectedFilter === filter.value 
                ? "bg-[#2D5B30] text-white" 
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
            onClick={() => setSelectedFilter(filter.value)}
          >
            {filter.label}
          </button>
        ))}
      </div>

      {/* Results */}
      <div className={`overflow-y-auto ${containerHeight} p-3`}>
        {loading ? (
          <div className="flex justify-center mt-10">
            <Loader />
          </div>
        ) : !query.trim() ? (
          <div className="flex justify-center items-center h-full mt-10 text-gray-400 body-N">
            Type to start searching...
          </div>
        ) : !results || results.total_results === 0 ? (
          <div className="flex justify-center items-center h-full mt-10 text-gray-500 body-N">
            No results found for "{query}"
          </div>
        ) : (
          <div className="flex flex-col gap-6 pb-4">
            {(selectedFilter === "all" || selectedFilter === "property") && results.properties && results.properties.length > 0 && (
              <div>
                <h3 className="head-5 green-H mb-3 px-1 border-b pb-1">Properties</h3>
                <div className="flex flex-col divide-y divide-gray-100">
                  {results.properties.map((prop) => (
                    <div
                      key={prop.id}
                      role="button"
                      className="py-3 px-2 hover:bg-gray-50 transition cursor-pointer"
                      onClick={() => handleNavigate("property", prop.id)}
                    >
                      <p className="head-6 dark-H">{prop.name}</p>
                      <p className="body-S dark-M">{prop.address?.street}, {prop.address?.city}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(selectedFilter === "all" || selectedFilter === "contact") && results.contacts && results.contacts.length > 0 && (
              <div>
                <h3 className="head-5 green-H mb-3 px-1 border-b pb-1">Contacts</h3>
                <div className="flex flex-col divide-y divide-gray-100">
                  {results.contacts.map((contact) => (
                    <div
                      key={contact.id}
                      role="button"
                      className="py-3 px-2 hover:bg-gray-50 transition cursor-pointer"
                      onClick={() => handleNavigate("contact", contact.id)}
                    >
                      <p className="head-6 dark-H">{contact.full_name}</p>
                      <p className="body-S dark-M">
                        {contact.email?.work && <span>{contact.email.work}</span>}
                        {contact.email?.work && contact.phone?.mobile && <span className="mx-2">•</span>}
                        {contact.phone?.mobile && <span>{contact.phone.mobile}</span>}
                        {contact.company_name && <span className="mx-2">•</span>}
                        {contact.company_name && <span className="italic">{contact.company_name}</span>}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(selectedFilter === "all" || selectedFilter === "company") && results.companies && results.companies.length > 0 && (
              <div>
                <h3 className="head-5 green-H mb-3 px-1 border-b pb-1">Companies</h3>
                <div className="flex flex-col divide-y divide-gray-100">
                  {results.companies.map((company) => (
                    <div
                      key={company.id}
                      role="button"
                      className="py-3 px-2 hover:bg-gray-50 transition cursor-pointer"
                      onClick={() => handleNavigate("company", company.id)}
                    >
                      <p className="head-6 dark-H">{company.company_name}</p>
                      <p className="body-S dark-M">
                        {company.email && <span>{cleanInfoString(company.email)}</span>}
                        {company.email && company.phone && <span className="mx-2">•</span>}
                        {company.phone && <span>{company.phone}</span>}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults;
